// The full-quality report tab's centre. Split out of Centre.tsx (hotspot
// decomposition); behaviour unchanged.

import { useLingui } from "@lingui/react/macro";
import type { ReactNode } from "react";
import { FullQualityView } from "../../../components/PolicyReport/PolicyReport.js";
import { useAppShell } from "../context.js";
import { spinnerSlot } from "./slots.js";

// A full-quality report tab's centre (owner decision: full quality is its
// own tab). The rich per-constraint drill-down is the standalone pure
// `FullQualityView`, fed the material's `PolicyEvaluation` from the
// per-material cache. A cache miss shows a spinner while the lazy-load
// effect sources it — never faked data.
export const QualityTabCentre = ({
    materialId,
}: {
    materialId: string;
}): ReactNode => {
    const { t } = useLingui();
    const { tabs, refFor, policyCache } = useAppShell();
    const evaluation = policyCache.get(materialId);
    if (evaluation === undefined)
        return spinnerSlot(t`Loading quality report…`);
    const title =
        tabs.qualityOpen.find((q) => q.materialId === materialId)?.title ??
        refFor(materialId)?.title ??
        materialId;
    return (
        <FullQualityView
            evaluation={evaluation}
            ariaLabel={t`Quality: ${title}`}
        />
    );
};
